import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-questionnaire-text',
  templateUrl: './questionnaire-text.component.html',
  styleUrls: ['./questionnaire-text.component.scss'],
})
export class QuestionnaireTextComponent implements OnInit {
    @Input() title: string;
    @Input() hint: string;
    @Input() answer: string;
    @Input() disabled = false;
    @Input() hasLine = false;

    constructor() {
    }

    ngOnInit() {
    }
}
